module.exports = __webpack_public_path__ + "img/tenxun.35ad889b.png";